import { useEffect } from 'react';
import { setDocumentTitleForPrintPreview } from '../utils/print';
import { BlankPrintableWaiver } from './BlankPrintableWaiver';

interface BlankWaiverPrintPreviewProps {
  studentName: string;
  onBack: () => void;
}

export function BlankWaiverPrintPreview({ studentName, onBack }: BlankWaiverPrintPreviewProps) {
  useEffect(() => {
    const cleanup = setDocumentTitleForPrintPreview('Student Waiver');
    return cleanup;
  }, [studentName]);

  return (
    <div>
      <div className="fixed top-4 right-4 z-50 space-x-4 print:hidden">
        <button
          onClick={() => window.print()}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Print / Save PDF
        </button>
        <button
          onClick={onBack}
          className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700"
        >
          Back
        </button>
      </div>

      <BlankPrintableWaiver />
    </div>
  );
}
